import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_assistente/assistente-virtual";

export const Route = createFileRoute("/_authenticated/assistente-virtual")({
  head: () => ({
    meta: [
      { title: "Assistente virtual — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Parametrização do assistente virtual: rotinas automáticas de acompanhamento da loja e avisos para a equipe.",
      },
      { property: "og:title", content: "Assistente virtual — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Parametrização do assistente virtual: rotinas automáticas de acompanhamento da loja e avisos para a equipe.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
